import Link from "next/link";
import { PlayersState } from "@/types/card";
import { LAYOUT_HEIGHTS } from "../constants";
import { PlayerBox } from "./PlayerBox";
import { HStack } from "styled-system/jsx";

import { FaRegCopy as IconCopy, FaUndoAlt as IconRestart} from "react-icons/fa";
import { useCopyToClipboard } from "@/utils/hooks/useCopy";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import { css } from "styled-system/css";

export const GameHeader = (props: { players?: PlayersState; onResetMatch?: () => void; }) => {
  const { query, pathname } = useRouter();
  const [, copy] = useCopyToClipboard();
  const playerKeys = Object.keys(props?.players ?? {}).filter(
    (key) => key !== "GLOBAL",
  );

  console.log("Header onResetMatch:", props.onResetMatch);

  const isSolo = pathname === "/solo";
  return (
    <div
      style={{
        //background: "rgba(62, 42, 22, 1)",
        background:"linear-gradient(90deg, rgba(181, 136, 88, 1) 50%, rgba(51, 32, 5, 1) 100%)",
        boxShadow: "0 2px 5px rgba(0,0,0,0.35)",
        borderBottom: "0px solid rgba(101, 101, 101, 0.73)",
        backdropFilter: "blur(4px)",

        padding: "0.5rem 1rem",
        height: LAYOUT_HEIGHTS.nav,
        display: "flex",
        gap: "2rem",
        overflowX: "auto",
        maxWidth: "100vw",
        scrollbarGutter: "stable both-edges",
        position: "relative",
      }}
    >
      {playerKeys?.map((key) => (
        <div key={key}>
          {isSolo ? (
            <Link href={{ query: { name: key } }}>
              {props?.players?.[key] && (
                <PlayerBox player={props?.players[key]} name={key} />
              )}
            </Link>
          ) : (
            <>
              {props?.players?.[key] && (
                <PlayerBox player={props?.players[key]} name={key} />
              )}
            </>
          )}
        </div>
      ))}
      <div
        style={{
          marginLeft: "auto",
          display: "flex",
          gap: "0.5rem",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        {props.onResetMatch && (
          <HStack
            bg="#7c2d12"
            color="white"
            borderRadius="2rem"
            p="0.25rem 1rem"
            className={IconStyle}
            onClick={props.onResetMatch}
          >
            <IconRestart />
            <p>Restart Match</p>
          </HStack>
        )}

        <HStack
          bg="white"
          borderRadius="2rem"
          p="0.25rem 1rem"
          className={IconStyle}
          onClick={() => {
            const base =
              typeof window !== "undefined" ? window.location.origin : "";
            const text = `${base}/online?gid=${query.gid}`;
            copy(text);
            toast.success(`Copied to clipboard`);
          }}
        >
          <IconCopy />
          <p>Share Lobby</p>
        </HStack>
      </div>
    </div>
  );
};

const IconStyle = css({
  userSelect: "none",
  transform: "scale(1)",
  transition: "all 0.25s ease",
  cursor: "pointer",
  _hover: {
    transform: "scale(1.1)",
    filter: "drop-shadow(0 0 2px rgba(0,0,0,0.25))",
  },
  _active: {
    transform: "scale(1.05)",
  },
});
